import { Button } from '@ophelos/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { CreditorLogo } from '@/components/debt/CreditorLogo';
import { SettingsMenu } from '@/components/ui/SettingsMenu';

interface DebtPageHeaderProps {
  backTo: string;
  /** Null when the surface spans creditors and no single mark would be honest. */
  creditor: { originalCreditor: string; creditorLogoUrl?: string } | null;
  /** The page's tab bar, shown on its own row under the creditor mark. */
  children: ReactNode;
}

export function DebtPageHeader({ backTo, creditor, children }: DebtPageHeaderProps) {
  return (
    <div className="flex flex-col items-center gap-3 max-w-5xl w-full mx-auto xs:p-4 sm:-mt-0.5 max-xs:pb-4 px-2">
      <div className="flex items-center justify-between gap-2 w-full max-xs:pt-4 mb-2">
        <Button asChild variant="subtle" size="icon" className="rounded-full max-sm:size-8">
          <Link to={backTo}>
            <ArrowLeft />
          </Link>
        </Button>
        {creditor && <CreditorLogo name={creditor.originalCreditor} logoUrl={creditor.creditorLogoUrl} />}
        <SettingsMenu size="icon" />
      </div>
      {children}
    </div>
  );
}
